<template>
  <p>
    The VIZBI 2012 posters are available at
    <a href="http://vizbi.org/Posters/2012/">vizbi.org/Posters/2012</a>.
  </p>
  <p>
    All conference participants had the opportunity to present a poster describing their work on
    visualizing biological data. Immediately prior to each poster session was a
    &lsquo;fast-forward&rsquo; session, where presenters had 60 seconds to introduce themselves and
    their work to all VIZBI participants.
  </p>
  <p>
    In addition, each participant was invited to upload one artistically-inspired image, displayed
    on monitors during the Art &amp; Biology event.
  </p>
  <h4 id="Virtual">Virtual Participation</h4>
  <p>
    Virtual registrants participated by uploading an electronic poster together with a maximum
    60-second video screencast. Uploaded videos were screened during fast-forward sessions.
  </p>
</template>
